<template>
  <div class="site-entry-history">
    <router-link :to="{ name: 'data-site-details', params: { id: site.id } }">
      View most recent activities
    </router-link>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    site: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.site-entry-history {
  font-family: Roboto;
  font-size: 11.2px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  & a {
    color: rgba(0, 0, 0, 0.87);
  }
}
</style>
